import { AppMessageHandler } from './app-message-handler';
import { BaseMessageProcessor } from './base-message-processor';
import { HostedWebContentAuthSdkService, IWindowAuthenticationService } from '../hosted-web-content-auth-sdk';
import { AuthenticationWindowMessageHandler } from './auth-window-message-handler';
import { HubSdkTelemetryService } from '../telemetry-service';

/**
 * MessageProcessor for processing the message requests related to authentication Frame context which involves :
 * Routing message requests to proper handler
 * Posting response back to the app
 */
export class AuthFrameMessageProcessor extends BaseMessageProcessor {
  /**
   * Registers different available handlers
   */
  constructor(
    protected appSdkHost: HostedWebContentAuthSdkService,
    protected authService: IWindowAuthenticationService,
    protected telemetryService?: HubSdkTelemetryService
  ) {
    super(appSdkHost);
    this.messageHandlers.push(new AuthenticationWindowMessageHandler(appSdkHost, authService, telemetryService));

    // In authentication FrameContext, App message handler doesnot need any hubservices
    this.messageHandlers.push(new AppMessageHandler(appSdkHost, {}, telemetryService));

    this.messageHandlers.forEach((handler) => handler.initHandlers());
  }
}
